import AxiosDefaultRequestConfig from './AxiosDefaultRequestConfig';
import AxiosPostProcessor from './AxiosPostProcessor';
import Axios, { AxiosResponse } from 'axios';

export class LogoutServiceStatic {
    logout(): Promise<AxiosResponse> {
        const url = `${process.env.VUE_APP_BASE_URL_API}/api/logout`
        return AxiosPostProcessor.postProcess(Axios.get(url, AxiosDefaultRequestConfig.merge({ })));
    }
}
const LogoutService = new LogoutServiceStatic();
export default LogoutService;
